import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ServiceIcon, SectionLabel } from "@/components/public/common";

function PageHero({ label, title, subtitle }) {
  return (
    <section className="tdw-hero-gradient text-white relative overflow-hidden">
      <div className="absolute inset-0 tdw-circuit opacity-50" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-tech mb-3">{`</> ${label}`}</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-slate-300 max-w-2xl text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}

export default function Services() {
  const { data: services } = useQuery({ queryKey: ["services"], queryFn: () => api.get("/services").then(r => r.data.services) });
  return (
    <div>
      <PageHero label="Services" title="Everything your business needs, in one place" subtitle="From websites and PC repair to workflow automation and AI — practical solutions designed to save you time." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid md:grid-cols-2 gap-6">
        {(services || []).map((s) => (
          <div key={s.id} className="rounded-2xl border border-slate-200 p-8 hover:shadow-lg transition-all">
            <div className="h-14 w-14 rounded-xl bg-gradient-to-br from-electric to-tech text-white grid place-items-center mb-5"><ServiceIcon name={s.icon} className="h-7 w-7" /></div>
            <h2 className="font-heading text-2xl font-bold text-navy">{s.name}</h2>
            <p className="mt-2 text-slate-600">{s.shortDescription}</p>
            <ul className="mt-4 grid grid-cols-2 gap-1.5">
              {(s.features || []).map((f, i) => <li key={i} className="text-sm text-slate-700 flex gap-1.5"><span className="text-electric">›</span> {f}</li>)}
            </ul>
            <div className="mt-6 flex gap-2">
              <Link to={`/services/${s.slug}`}><Button variant="outline" data-testid={`services-detail-${s.slug}`}>Details</Button></Link>
              <Link to="/request-service"><Button className="bg-electric hover:bg-tech">Request <ArrowRight className="h-4 w-4 ml-1" /></Button></Link>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}

export { PageHero };
